import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { GetAutomationListRequestDto } from "../dtos/get-automation-list-request-dto";

export const AutomationQueryKeys = createQueryKeys("automation", {
  getAutomationList: ({
    q,
    page,
    limit,
    sort
  }: GetAutomationListRequestDto) => [q, page, limit, sort],
  getAutomationDetail: (id: string) => [id],
  getAutomationSummary: (id: string) => [id],
  getAutomationNotifySetup: (id: string) => [id]
});
